
class Courier {
	constructor(request) {
		this.request = request
		this.endpoint = 'courier'
	}

	GetDeliveryFee(locationCode, orgid) {
		const body = {
			"locationcode":locationCode,
			"orgid": orgid
		}
		return this.request.send(
			`${this.endpoint}/deliveryfee/location`,
			'POST',
			body,
		)

	}
}


export default Courier